import { render } from "./Container.vue?vue&type=template&id=6885bd4a"
import script from "./Container.vue?vue&type=script&lang=ts"
export * from "./Container.vue?vue&type=script&lang=ts"
script.render = render

export default script